import {FC, useCallback, useState, createContext, useContext} from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import {
  getInvoiceListBaseMode,
  getInvoiceListTargetFilter,
  getInvoiceListTargetInvoiceId,
  getInvoiceListTargetSearch,
} from './invoiceListTarget'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const getInitialInvoiceQueryState = (): QueryState => {
  // One invoice by its id, or a search such as an alert SMS's tax id: every season is searched,
  // in the list the address names (an archived invoice opens in the archive).
  const targetSearch = getInvoiceListTargetInvoiceId() || getInvoiceListTargetSearch()
  if (targetSearch) {
    return {
      ...initialQueryRequest.state,
      baseMode: getInvoiceListBaseMode(),
      invoiceSeason: 'all',
      filter: {search: targetSearch},
    }
  }

  // A dashboard link (a batch's «دارای خطا», a goods/services row, a status card): the list
  // opens with that filter, shown as removable chips. A registration date range makes the
  // request read every season by itself (stringifyRequestQuery).
  const targetFilter = getInvoiceListTargetFilter()
  if (targetFilter) {
    return {
      ...initialQueryRequest.state,
      baseMode: 1,
      filter: targetFilter,
    }
  }

  return initialQueryRequest.state
}

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<QueryState>(getInitialInvoiceQueryState)

  const updateState = useCallback((updates: Partial<QueryState>) => {
    setState((previousState) => ({...previousState, ...updates} as QueryState))
  }, [])

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}
